import { Box, Card, IconButton, Tooltip } from '@material-ui/core';
import React, { CSSProperties, useEffect, useState } from 'react';
import Iconify from '../../component/iconify/Iconify';
import PieChartSelection from './Chart';
import ChartTable from './chartTable';

const INFO_TOOLTIP = 'Metrics based on active subscriptions only';

const styles = {
  pichartSection: { height: '100%' },
  pichartBoxSection: { padding: '16px' },
  titleRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    paddingBottom: '2%',
  },
  tittle: {
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '1.5rem',
    fontWeight: '600',
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    lineHeight: 1.5,
    margin: 0,
  },
};

type SubscriptionTypesData = {
  monthly?: number;
  yearly?: number;
  lifetime?: number;
};

const LABELS = ['Monthly', 'Yearly', 'Lifetime'];
const PIE_CHART_SIZE = 390;

const SubscriptionTypesChart = (props: {
  subscriptionTypesData?: SubscriptionTypesData | null;
}) => {
  const { subscriptionTypesData } = props;
  const [series, setSeries] = useState<number[]>([]);
  const [chartData, setChartData] = useState<{ type: string; count: number }[]>(
    []
  );
  const [options, setOptions] = useState<any>({
    chart: {
      type: 'pie',
      id: 'subscription-types',
      // width: PIE_CHART_SIZE,
    },
    responsive: [
      {
        breakpoint: undefined,
        options: {
          // chart: { width: PIE_CHART_SIZE },
          legend: { position: 'bottom' },
        },
      },
    ],
  });

  const title = 'Subscription Type';
  const columns = [
    { field: 'type', headerName: 'Type' },
    { field: 'count', headerName: 'Count' },
  ];

  useEffect(() => {
    const data = subscriptionTypesData ?? {};
    const rows = LABELS.map((label) => ({
      type: label,
      count: Number(
        data[label.toLowerCase() as keyof SubscriptionTypesData] ?? 0
      ),
    }));
    setChartData(rows);
    setSeries(rows.map((r) => r.count));
    setOptions((prev: any) => ({ ...prev, labels: LABELS }));
  }, [subscriptionTypesData]);

  const allZero = chartData.every((r) => r.count === 0);

  return (
    <Card style={styles.pichartSection as CSSProperties}>
      <Box style={styles.pichartBoxSection as CSSProperties}>
        <div style={styles.titleRow as CSSProperties}>
          <span style={styles.tittle as CSSProperties}>{title}</span>
        </div>
        {!allZero ? (
          <div style={{ width: PIE_CHART_SIZE, minHeight: 220 }}>
            <PieChartSelection
              series={series}
              options={options}
              title={title}
              next="subscription-types"
            />
          </div>
        ) : (
          <div style={{ padding: '16px 0', color: 'rgba(0,0,0,0.6)' }}>
            No subscription type data for the selected period.
          </div>
        )}
        <ChartTable rows={chartData} columns={columns} />
      </Box>
    </Card>
  );
};

export default SubscriptionTypesChart;
